export default '6.24.1';